export enum OrderStatus {
  Canceled = 0, 
  Completed = 1,
  Failed = 2,
  InProgress = 3,
  Pending = 4,
}
